module.exports = __webpack_public_path__ + "img/call_silent.5fa0f6a4.svg";